import log from '../../../src/shared/util/log';
import { Clinics } from '../../../src/shared/components/pet-form/VetClinic/vetClinicResponse';
import { handleFetchError } from '../../../src/shared/util/handleFetchError';
import {
  AssignVetClinicAPI,
  UnassignVetClinicAPI,
  VetClinicAPI,
} from '../components/pet-form/VetClinic/vetClinicApiType';
import constant from './constant';

export const handleVetClinicError = (error: any, apiName: string) =>
  error.response ? handleFetchError(error.response, apiName) : handleFetchError(error, apiName);

export const vetClinicApi: VetClinicAPI = {
  get: async () => {
    let response;
    try {
      response = await fetch('/api/petprofile/kyriosb/v1/clinicorgs');
      if (response.status !== 200) {
        handleVetClinicError(
          `fetchError: vetClinicApi returned error status ${response.status}`,
          'getClinics',
        );
        return [];
      }
      const responseJson = await response.json();
      return responseJson;
    } catch (error) {
      throw handleVetClinicError(error, 'getClinics');
    }
  },
};

export const getPetClinics = async ({ queryKey: [,] }: { queryKey: [any] }) =>
  new Promise<Clinics>((resolve, reject) => {
    vetClinicApi
      .get()
      .then(resolve)
      .catch((error) => {
        log.error('An error occurred while getting pet clinics', error);
        reject(handleVetClinicError(error, 'getPetClinics'));
      });
  });

const GET_PET_CLINICS = 'GET_PET_CLINICS';
getPetClinics.key = GET_PET_CLINICS;
getPetClinics.requiresPetId = false;

export const createVetClinicApi = {
  create: async (name: string, phone: string, postcode?: string) => {
    let response;
    try {
      response = await fetch('/api/petprofile/kyriosb/v1/clinicorgs', {
        method: constant.POST,
        headers: { ...constant.httpHeaderContentTypeJSON },
        body: JSON.stringify({
          name: name,
          address: {
            phone1: phone,
            postcode: postcode,
          },
        }),
      });
      if (response.status !== 200) {
        handleVetClinicError(
          `fetchError: CreateVetClinicAPI returned error status ${response.status}`,
          'createClinic',
        );
        return false;
      }
      const responseJson = await response.json();
      return responseJson;
    } catch (error) {
      throw handleVetClinicError(error, 'createClinic');
    }
  },
};

export const assignVetClinicApi: AssignVetClinicAPI = {
  assign: async (clinic_id: number) => {
    let response;
    try {
      response = await fetch(`/api/petprofile/kyriosb/v1/affiliations/${clinic_id}`, {
        method: constant.POST,
        headers: { ...constant.httpHeaderContentTypeJSON },
      });
      if (response.status !== 200) {
        handleVetClinicError(
          `fetchError: AssignVetClinicAPI returned error status ${response.status}`,
          'assignClinic',
        );
        return [];
      }
      const responseJson = await response.json();
      return responseJson;
    } catch (error) {
      throw handleVetClinicError(error, 'assignClinic');
    }
  },
};

export const unassignVetClinicApi: UnassignVetClinicAPI = {
  unassign: async (clinic_id: number) => {
    let response;
    try {
      const url = `/api/petprofile/kyriosb/v1/affiliations/${clinic_id}`;
      response = await fetch(url, {
        method: constant.DELETE,
        headers: { ...constant.httpHeaderContentTypeJSON },
      });
      if (response.status !== 200) {
        handleVetClinicError(
          `fetchError: UnassignVetClinicAPI returned error status ${response.status}`,
          'unassignClinic',
        );
      }
      return;
    } catch (error) {
      throw handleVetClinicError(error, 'unassignClinic');
    }
  },
};

export const findClinicsPaginated = {
  get: async (query: string, start = 0, limit = 50) => {
    try {
      const url = `/api/petprofile/kyriosb/v1/clinicorgs/search?q=${encodeURIComponent(query)}`;
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          recordSetStart: `${start}`,
          recordSetLimit: `${limit}`,
        },
      });
      if (response.status !== 200) {
        handleVetClinicError(
          `fetchError: findClinicsPaginatedAPI returned error status ${response.status}`,
          'searchClinics',
        );
        return;
      }
      const responseJson = await response.json();
      return responseJson;
    } catch (error) {
      throw handleVetClinicError(error, 'searchClinics');
    }
  },
};

export const findClinicsByPhone = {
  get: async (phone: string, start = 0, limit = 50) => {
    try {
      const url = `/api/petprofile/kyriosb/v1/clinicorgs/search?phone=${encodeURIComponent(
        phone,
      )}&verifiedInd=true`;
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          recordSetStart: `${start}`,
          recordSetLimit: `${limit}`,
        },
      });
      if (response.status !== 200) {
        handleVetClinicError(
          `fetchError: findClinicsPaginatedAPI returned error status ${response.status}`,
          'clinicsByPhone',
        );
        return;
      }
      return await response.json();
    } catch (error) {
      throw handleVetClinicError(error, 'clinicsByPhone');
    }
  },
};
